import React from 'react';

import {
	AgentProfileCardResourced,
	type AgentProfileCardResourcedProps,
} from '@atlaskit/profilecard/agent-profile-card-resourced';

export type AgentCardProps = AgentProfileCardResourcedProps;

/**
 * Profile card for a Rovo agent principal.
 *
 * 1. Forwards all props to `AgentProfileCardResourced` from `@atlaskit/profilecard`.
 * 2. The wrapped component owns Suspense + ErrorBoundary internally, so this
 *    component is safe to render directly inside a popup body without extra
 *    fallback.
 */
export function AgentCard(props: AgentCardProps): React.JSX.Element {
	return <AgentProfileCardResourced {...props} />;
}
